import { Skeleton, Tabs, TabsProps } from 'antd';
import { PrintableRootPage } from 'components/page/page-2';
import { useClinicianContext } from '../../../lib/hooks/use-resolveCurrentClinicInfo';
import { ClinicianTable } from './components/user-table/user-table-clinician';
import { PatientTable } from './components/user-table/user-table-patient/user-table-patient';
import { Text } from 'components/mvp-typography';

export default function ClinicUserManagement() {
  const clinicianInfo = useClinicianContext();

  if (!clinicianInfo.currentClinic) {
    return <Skeleton />;
  }
  const items: TabsProps['items'] = [
    {
      label: 'Test-takers',
      key: 'test-takers',
      children: <PatientTable clinicId={clinicianInfo.currentClinic} />
    },
    {
      label: 'Clinicians',
      key: 'clinicians',
      children: <ClinicianTable clinicId={clinicianInfo.currentClinic} />
    }
  ];

  return (
    <PrintableRootPage title="User management">
      <Text>Create, modify, and manage all the users in your Clinic.</Text>
      <Tabs items={items} defaultActiveKey="test-takers" />
    </PrintableRootPage>
  );
}
